export default {
      id: "linkedin-new-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "sprite.svg#linkedin-new",
      toString: function () {
        return this.url;
      }
    }